module.exports = __webpack_public_path__ + "static/media/4XL.2f07c2e1.jpg";